<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">舆情列表</div>
        <el-row type="flex" justify="start" style="margin: 10px 0">
          <div class="rowList">
            <div class="rowT">监测时间</div>
            <div
              class="rowC"
              :class="timeChecked === 'all' ? 'rowC_checked' : ''"
              @click="handleTime('all')"
            >
              全部
            </div>
            <div v-for="(item, index) in monitorTimes" :key="index">
              <div
                class="rowC"
                :class="timeChecked === item.key ? 'rowC_checked' : ''"
                @click="handleTime(item.key)"
              >
                {{ item.value }}
              </div>
            </div>
          </div>
        </el-row>
        <el-row type="flex" justify="start" style="margin: 10px 0">
          <div class="rowList">
            <div class="rowT">信息属性</div>
            <div
              class="rowC"
              :class="statesChecked === 'all' ? 'rowC_checked' : ''"
              @click="handleState('all')"
            >
              全部
            </div>
            <div v-for="(item, index) in infoStates" :key="index">
              <div
                class="rowC"
                :class="statesChecked === item.key ? 'rowC_checked' : ''"
                @click="handleState(item.key)"
              >
                {{ item.value }}
              </div>
            </div>
          </div>
        </el-row>
        <el-row type="flex" justify="space-between" style="margin: 10px 0">
          <el-col :span="20">
            <div class="rowList">
              <div class="rowT">来源类型</div>
              <div
                class="rowC"
                :class="sourcesChecked === 'all' ? 'rowC_checked' : ''"
                @click="handleSource('all')"
              >
                全部
              </div>
              <div v-for="(item, index) in sourceTypes" :key="index">
                <div
                  class="rowC"
                  :class="sourcesChecked === item.key ? 'rowC_checked' : ''"
                  @click="handleSource(item.key)"
                >
                  {{ item.value }}
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="2">
            <div class="rowT">
              <el-button @click="onSearch">查 询</el-button>
            </div>
          </el-col>
        </el-row>

        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column label="标题" show-overflow-tooltip
                ><template slot-scope="{ row }">
                  <el-link
                    :href="row.FirstWebUrl"
                    target="_blank"
                    class="buttonText"
                    type="primary"
                    :underline="false"
                    >{{ row.Title }}</el-link
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="ProjectId"
                label="所属项目"
                width="100"
                align="center"
                :formatter="formatProject"
              ></el-table-column>
              <el-table-column
                prop="Keywords"
                label="涉及词"
                width="100"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="FirstWebContentSite"
                label="站点来源"
                width="100"
                align="center"
                show-overflow-tooltip
              ></el-table-column>

              <el-table-column
                prop="Similarity"
                label="相似文章"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                label="舆情性质"
                prop="State"
                width="80"
                align="center"
              >
                <template slot-scope="scope">
                  <span class="iconGood" v-if="scope.row.State == 1">正面</span>
                  <span class="iconBad" v-else-if="scope.row.State == 2"
                    >负面</span
                  >
                  <span class="iconBad" v-else>中立</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="CreateTime"
                :formatter="formatDate"
                label="监测时间"
                width="180"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "OpinionTopics",
  controller: "UI",
  action: "OpinionTopics",
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      monitorTimes: [
        { key: "0", value: "今天" },
        { key: "1", value: "24小时" },
        { key: "2", value: "2天" },
        { key: "3", value: "3天" },
        { key: "7", value: "7天" },
        { key: "10", value: "10天" },
      ],
      timeChecked: "all",
      infoStates: [
        { key: "1", value: "正面" },
        { key: "2", value: "负面" },
      ],
      statesChecked: "all",
      sourceTypes: [
        { key: "gov", value: "政府网" },
        { key: "PortalsNewsCf", value: "新闻网" },
        { key: "PortalsCf", value: "门户网站" },
        { key: "OnlineRetailers", value: "电商网" },
        { key: "SearchEngines", value: "搜索引擎" },
        { key: "bbs", value: "论坛" },
        { key: "weibo", value: "微博" },
        { key: "weixin", value: "微信" },
      ],
      sourcesChecked: "all",
      projects: [],
    };
  },
  mounted: function () {
    this.getProjects();
    this.logInfo.ActionName = "舆情列表查看";
    this.logInfo.LogMessage = "舆情列表查看";
    this.logInfo.ModuleName = "实时舆情";
    this.logInfo.PageName = "舆情列表页";
    this.addOperationLog();
  },
  methods: {
    //点击监测时间
    handleTime(val) {
      this.timeChecked = val;
    },
    //点击信息属性
    handleState(val) {
      this.statesChecked = val;
    },
    //点击来源类型
    handleSource(val) {
      this.sourcesChecked = val;
    },
    getProjects() {
      let that = this;
      new MyApis.OpinionProjectApi()
        .GetProjects({})
        .then((r) => {
          r = r.data.Data;
          this.projects = r || [];
          this.search();
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    search() {
      let that = this;
      let searchInfo = {
        InfoState: this.statesChecked === "all" ? "" : this.statesChecked,
        SourceType: this.sourcesChecked === "all" ? "" : this.sourcesChecked,
        WatchDateType: this.timeChecked === "all" ? "" : this.timeChecked,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.OpinionApi()
        .GetAnalysises(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    formatProject(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const ProjectName = this.projects
        .map((item) => {
          if (item.ProjectID == data) return item.ProjectName;
        })
        .join("");
      if (ProjectName == null || ProjectName == "") {
        return "";
      }
      return ProjectName;
    },
  },
};
</script>
<style scoped>
.rowList {
  display: flex;
}
.rowT {
  width: 10rem;
  height: 3.5rem;
  text-align: center;
  line-height: 3.5rem;
}
.rowC {
  min-width: 6rem;
  height: 3.5rem;

  border-radius: 4px;
  margin: 0 1rem;
  text-align: center;
  line-height: 3.5rem;
  color: #428bca;
  cursor: pointer;
  padding: 0 5px;
}
.rowC:hover {
  background-color: #fff;
  color: #428bca;
}
.rowC_checked {
  background-color: #428bca;
  color: #fff;
}
</style>
